import { Button, Col, Form, Input, Row, Select, Typography } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { StudyProgram, StudentUser, UpdateStudentUser } from "@bindeleddet/core/types";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ChangePassword from "./ChangePassword";
import ChangeStudyProgramModal from "./ChangeStudyProgramModal";
import MyProfileToolCard from "../../MyProfileToolCard/MyProfileToolCard";

const { Option } = Select;

const EditProfile = () => {
  const { currentUser } = useLoginContext();
  const [studyPrograms, setStudyPrograms] = useState<StudyProgram[]>([]);
  const [changePassword, setChangePassword] = useState<boolean>(false);
  const [changeStudyProgramModalOpen, setChangeStudyProgramModalOpen] = useState<boolean>(false);

  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    axios.get<StudyProgram[]>("/students/study-program/").then(response => setStudyPrograms(response.data));
  }, [currentUser]);

  if (isCompanyUser(currentUser) || !currentUser) return null;

  const updateStudent = async (values: UpdateStudentUser) => {
    try {
      await axios.put<StudentUser>(`/students/${currentUser?.id}/`, {
        ...currentUser,
        first_name: values.first_name,
        last_name: values.last_name,
        mobile_number: values.mobile_number,
        allergies: values.allergies,
        updated_at: new Date().toISOString(),
      });
      history.push("/student-profile/");
      message("success", "Profil oppdatert");
      currentUser.first_name = values.first_name;
      currentUser.last_name = values.last_name;
      currentUser.mobile_number = values.mobile_number;
      currentUser.allergies = values.allergies;
    } catch (error) {
      message("error", "Kunne ikke oppdatere profil");
    }
  };

  return (
    <MyProfileToolCard title="Rediger profil" onBack={() => history.push("/student-profile")}>
      <Form form={form} layout="vertical" requiredMark onFinish={updateStudent}>
        <Row gutter={[16, 1]}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Fornavn"
              name="first_name"
              initialValue={currentUser.first_name}
              rules={[{ required: true, message: "Vennligst skriv inn fornavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Etternavn"
              name="last_name"
              initialValue={currentUser.last_name}
              rules={[{ required: true, message: "Vennligst skriv inn etternavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Mobilnummer"
              name="mobile_number"
              initialValue={currentUser.mobile_number}
              rules={[{ required: true, message: "Vennligst skriv inn telefonnummer" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Epost" name="email" initialValue={currentUser.email}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Linje" name="studyProgramme" initialValue={currentUser.study_programme}>
              <Select disabled>
                {studyPrograms.map(program => {
                  return (
                    <Option value={program.id} key={program.id}>
                      {program.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Button
              type="text"
              style={{ padding: 0, marginBottom: "16px" }}
              onClick={() => setChangeStudyProgramModalOpen(true)}
            >
              <Typography.Text underline>Endre linje eller årskull?</Typography.Text>
            </Button>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Årskull" name="year" initialValue={currentUser.year_level}>
              <Select disabled>
                <Option value={1}>1. klasse</Option>
                <Option value={2}>2. klasse</Option>
                <Option value={3}>3. klasse</Option>
                <Option value={4}>4. klasse</Option>
                <Option value={5}>5. klasse</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            {/* TODO sørg for at ikke brukernavn fylles inn som allergi automatisk */}
            <Form.Item
              label="Allergier"
              name="allergies"
              initialValue={currentUser.allergies ?? ""}
              tooltip="Hvis du har flere allergier, skill med komma."
            >
              <Input autoComplete="allergies" />
            </Form.Item>
          </Col>
          {/*
          <Col xs={24} sm={24} md={12}>
            <Checkbox>
              <Text style={{ fontSize: "1.1em" }}>Bindeleddet NTNU mailliste</Text>
              <Paragraph>
                Bindeleddet NTNU sender deg informasjon om kommende presentasjoner og andre aktiviteter i Bindeleddet
                NTNUs regi
              </Paragraph>
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Checkbox>
              <Text style={{ fontSize: "1.1em" }}>Bedrift mailliste</Text>
              <Paragraph>Bedrifter kan sende deg informasjon om sommerjobber, stillinger og lignende</Paragraph>
            </Checkbox>
          </Col>
              */}
        </Row>
        <br />
        <Row gutter={[16, 1]}>
          <Col xs={12} sm={12} md={12}>
            <Button onClick={() => setChangePassword(!changePassword)}>Endre passord?</Button>
          </Col>
          <Col xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
            <Form.Item>
              <Button size="large" type="primary" htmlType="submit">
                Lagre
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <ChangePassword open={changePassword} setOpen={setChangePassword} userId={currentUser.id} />
      <ChangeStudyProgramModal
        open={changeStudyProgramModalOpen}
        onClose={() => setChangeStudyProgramModalOpen(false)}
        studyPrograms={studyPrograms}
        currentUser={currentUser}
      />
    </MyProfileToolCard>
  );
};

export default EditProfile;
